
export {
    defaults as barchart
} from './barchart';

export {
    defaults as gauge
} from './gauge';

export {
    defaults as heatmap
} from './heatmap';

export {
    defaults as linechart
} from './linechart';

export {
    defaults as network
} from './network';

export {
    defaults as piechart
} from './piechart';

export {
    defaults as scatterplot
} from './scatterplot';

export {
    defaults as stackedarea
} from './stackedArea';

export {
    defaults as streamgraph
} from './streamgraph';

export {
    defaults as sunburst
} from './sunburst';

export {
    defaults as swimlane
} from './swimlane';

export {
    defaults as parallelcoordinates
} from './parallelCoordinates';



// WEBPACK FOOTER //
// ./src/utils/defaults/index.ts